<template>
    <v-autocomplete
        :append-icon="selectedState  ? null : 'expand_more'"
        :background-color="selectedState ? 'primary' : ''"
        :class="`geography-selector${selectedState ? '--selected' : ''}`"
        @clear="backToUsMap"
        clearable
        clear-icon="close"
        dense
        filled
        height="30"
        hide-details
        hide-no-data
        :items="states"
        prepend-inner-icon="place"
        outlined
        item-text="name"
        item-value="abbr"
        :label="$vuetify.breakpoint.smAndDown ? 'State' : 'Select a state'"
        rounded
        single-line
        v-model="selectedState">
    </v-autocomplete>
</template>

<script>
    import stateStats from "../../constants/stateStats.json";

    export default {
        name: "geography-selector",
        data() {
            return {
                stateStats: stateStats
            }
        },
        computed: {
            selectedState: {
                get(){
                    if(this.$route.name == 'state'){
                        return this.$route.params.state.toUpperCase();
                    } else {
                        return null;
                    }
                },
                set(state){
                    if(state){
                        this.$router.push({
                            name: 'state',
                            params: {
                                state: state.toLowerCase()
                            }
                        });
                    } else {
                        this.$router.push({
                            name: 'all'
                        })
                    }
                },
            },
            states() {
                let states = [];
                for (const [key, value] of Object.entries(this.stateStats)) {
                    if(key != 'USA' && key != ""){
                        states.push({
                            abbr: key,
                            name: value.name
                        });
                    }
                }
                return states;
            },
        },
        methods: {
            backToUsMap(){
                if(window.history.length > 0){
                    this.$router.go(-1);
                } else {
                    this.$router.push({ name: 'all'});
                }
                this.selectedState = null;
            }
        }
    }
</script>

<style lang="scss">
    .geography-selector{
        .v-input__icon--clear{
            opacity: 1;
        }

        .v-input__slot{
            padding: 0 16px!important;
        }

        &--selected{
            .v-input__slot{
                padding: 0 16px!important;
            }
            .v-input__icon.v-input__icon--prepend-inner .v-icon{
                color: white!important;
            }
            .v-select__slot{
                input, .v-icon {
                    color: white!important;
                }
            }
        }
    }

</style>